import { useEffect, useState } from "react";
import { Subscription } from "../../../contracts/nexar-api/types";
import { useDI } from "../../../core/di";

/**
 * Returns the subscriptions associated with the current user
 * Null = Not resolved yet
 * [] (empty array) = Resolved but there are no subscriptions
 * [...] = Data
 */
export default function useUserSubscriptions() {
  const [subscriptions, setSubscriptions] = useState<Subscription[] | null>(
    null
  );
  const { nexarApi } = useDI();

  useEffect(() => {
    let flag = true;
    nexarApi
      .getSubscriptionsWithModules()
      .then(({ data }) => {
        if (flag) {
          if (data === null) {
            // stop the preloaders by treating the data as empty in case of error
            setSubscriptions([]);
          } else {
            setSubscriptions(data);
          }
        }
      })
      .catch(() => {
        if (flag) {
          setSubscriptions([]);
        }
      });
    return () => {
      flag = false;
    };
  }, []);

  return { subscriptions };
}
